import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class TravelBillService {
    constructor(private datatask: DataTaskService) {}

    public async getEdit(params: TravelBillEditParams): Promise<TravelBillGet> {
        return (await this.datatask.Post(1255, params))[0];
    }

    public listLabours(): Promise<TravelBillLabour[]> {
        return this.datatask.Post(1252);
    }

    public listProjects(params: { cust_no: string }): Promise<TravelBillProject[]> {
        return this.datatask.Post(1108, params);
    }

    public loadSpecialResourcesFrom(custact_no: string): Promise<TravelBillResource[]> {
        return this.datatask.Post(1461, { custact_no });
    }

    public async updateDietDaysInfo(params: { start_dt: string; end_dt: string }): Promise<TravelBillDietInfo> {
        return (await this.datatask.Post(1264, params))[0];
    }

    public async save(page: TravelBillGet): Promise<TravelBillSaveResponse> {
        return (await this.datatask.Post(1256, page))[0];
    }
}

export interface TravelBillEditParams {
    argtype: string;
    argvalue: string;
    travelbill_no: string;
}

export interface TravelBillGet {
    travelbill_no: string;
    sr: string;
    labour_no?: string;
    labour_name?: string;
    special_resource_id_from?: string;
    travel_goal?: string;
    cust_no: string;
    cust_name: string;
    project_keyno: string;
    projectprosess_keyno: string;
    projectprocess_keyno?: string;
    custact_no: string;
    custact_note?: string;
    place_of_departure?: string;
    destination?: string;
    start_dt: string;
    end_dt: string;
    diet_days: string | number;
    diet_hours: string | number;
    nights: string | number;
    nbr_of_days: string | number;
    page_heading?: string;
    show_setting?: string;
}

export interface TravelBillLabour {
    labour_no: string;
    labour_name: string;
    orderby?: number;
}

export interface TravelBillProject {
    project_keyno: string;
    project_name: string;
    orderby?: number;
}

export interface TravelBillResource {
    resource_id: string;
    resource_name: string;
}

export interface TravelBillDietInfo {
    diet_days: string | number;
    diet_hours: string | number;
    nights: string | number;
    nbr_of_days: string | number;
}

export interface TravelBillSaveResponse {
    errorcode: string;
    errormessage: string;
}
